module.exports = "pegasus_template/assets/blocks/pop-up-element-text-02.png";